import React, { useEffect } from 'react';
import './styles.scss';
import HoursContainer from '../Hours/Hours';
import CountDownTimer from '../CountDownTimer/CountDownTimer';
import PieChart from '../PieChart/PieChart';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getSettings } from 'store/settings/settingsOperations';
import settingsSelectors from 'store/settings/settingsSelectors';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { hasPermissionsFor } from 'helpers/_helpers';
import { isAvailabilityEnabled, isScheduleOnly } from 'common/permissions';
import { onDSLogin } from 'pages/Settings/components/SettingsForm/components/ShiftsBlock/WorkShiftsHeader/WorkShiftsHeader';

const GeneralInfoBlock = ({
  user,
  selectedUser,
  data,
  isDocuSignUnauthorized,
  docuSignPermissions,
}) => {
  const navigate = useNavigate();
  const matches = useMediaQuery(
    'screen and (max-width: 1367px) and (orientation: landscape), (max-width: 1024px)'
  );
  const isMobile = useMediaQuery('(max-width: 550px)');

  const mobileKioskAccess = matches && hasPermissionsFor('kioskModeMobile');

  const path = `${process.env.REACT_APP_BASE_URL}/organization-locations/settings/homepage-image?imageKey=`;
  const userRole = user.profile.role.roleName;
  const remoteKioskPermission = hasPermissionsFor('remoteKiosk');
  const permissionScheduleButton =
    userRole !== 'Accounting' && userRole !== 'Machine Shop' && userRole !== 'Fleet Maintenance';
  const permissionWorklogButton =
    userRole !== 'Machine Shop' && userRole !== 'Accounting' && userRole !== 'Fleet Maintenance';

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSettings());
  }, []);

  const settingsIsReady = useSelector(settingsSelectors.getAllSettings);
  const desktopImage = useSelector(settingsSelectors.getDesktopImage);
  const mobileImage = useSelector(settingsSelectors.getMobileImage);
  const image = isMobile ? mobileImage : desktopImage;
  const title = useSelector(settingsSelectors.getTitle);
  const toggleCountdownEnabled = useSelector(settingsSelectors.getToggleCountdownEnabled);
  const titleColor = useSelector(settingsSelectors.getTitleColor);
  const countdownTitle = useSelector(settingsSelectors.getCountdownTitle);
  const countdownDate = useSelector(settingsSelectors.getCountdownDate);
  const locationSettings = useSelector(state => state.personalProfile.organizationLocation?.settings);
  const organization = useSelector(state => state.personalProfile.organization);
  const scheduleOnly = isScheduleOnly(organization);
  const availabilityEnabled = isAvailabilityEnabled(locationSettings);
  //* Schedule-Only has no kiosk — the stale kioskModeMobile flag must not divert this button
  const kioskButton = scheduleOnly
    ? {
        label: 'Request time off',
        path: '/remote-kiosk',
        visible: remoteKioskPermission && availabilityEnabled,
      }
    : {
        label: remoteKioskPermission || mobileKioskAccess ? 'Remote Kiosk' : 'Request time off',
        path: mobileKioskAccess ? '/mobile-kiosk' : '/remote-kiosk',
        visible: true,
      };
  const showHours = !!locationSettings?.timeclock;
  const imagePath = image ? `${path}${image && image.imageKey}` : null;
  const userName = user?.profile?.fullName.split(' ')[0] || user.username;

  return (
    <>
      <div className="main-general-info-wrapper">
        <div
          className="main-container"
          style={{
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          {imagePath && (
            <img className="main-continer-image" src={settingsIsReady && imagePath} alt="" />
          )}
          <div className="header-title">
            <h3 className="main-container-title-mobile">Hi, {userName}!</h3>
            {docuSignPermissions && isDocuSignUnauthorized && (
              <div className="mobile-primary-text" onClick={onDSLogin}>
                Login to DocuSign
              </div>
            )}
          </div>
          {title && (
            <div className="main-container-bcg">
              <p className="main-container-text" style={{ color: titleColor }}>
                {title || ' '}
              </p>
            </div>
          )}

          <div className="main-container-btn">
            {permissionScheduleButton && (
              <button
                className="main-button"
                type="button"
                onClick={
                  hasPermissionsFor('activeSchedule')
                    ? () => navigate('/schedule-user')
                    : () => navigate('/schedule')
                }
              >
                <span className="button-text">
                  {hasPermissionsFor('activeSchedule') ? 'View my schedule' : 'Schedule'}
                </span>
              </button>
            )}
            {permissionWorklogButton && (
              <button className="main-btn" type="button" onClick={() => navigate('/worklog')}>
                <span className="btn-text"> Add worklog</span>
              </button>
            )}
            {kioskButton.visible && (
              <button className="main-btn" type="button" onClick={() => navigate(kioskButton.path)}>
                <span className="btn-text">{kioskButton.label}</span>
              </button>
            )}
          </div>
        </div>
        {(showHours || availabilityEnabled) && (
          <div className="statistic-info-block">
            {showHours && <HoursContainer data={data.workedHours} user={user} />}
            {availabilityEnabled && (
              <PieChart data={data.timeoffSummary} user={user} selectedUser={selectedUser} />
            )}
          </div>
        )}
        {toggleCountdownEnabled && (
          <CountDownTimer deadline={new Date(countdownDate)} title={countdownTitle} />
        )}
      </div>
    </>
  );
};

export default GeneralInfoBlock;
